import React from 'react';
import { Typography } from '@mui/material';
import PasswordField from './PasswordField';
import {
  stateColorSwitch,
  checkPassLength,
  checkPassLettersAndNumbers,
  checkPassSpecialCharacter,
  checkPassDiff,
  requestStyle,
} from './helpers';

type PasswordFormProps = {
  setPassword: (password: string) => void,
  setError: (error: boolean) => void,
  disabled?: boolean,
}

function PasswordForm(props: PasswordFormProps) {
  const { setPassword, setError, disabled } = props;

  const [firstPassword, setFirstPassword] = React.useState('');
  const [lastPassword, setLastPassword] = React.useState('');

  const checkLength = checkPassLength(firstPassword);
  const checkLettersAndNumbers = checkPassLettersAndNumbers(firstPassword);
  const checkSpecialCharacters = checkPassSpecialCharacter(firstPassword);
  const passDiff = checkPassDiff(firstPassword, lastPassword);

  const checkPasswordsAndErrors = () => [checkLength, checkLettersAndNumbers, checkSpecialCharacters, passDiff].includes('error')
    || [checkLength, checkLettersAndNumbers, checkSpecialCharacters, passDiff].includes(null);

  React.useEffect(() => {
    if (!checkPasswordsAndErrors()) {
      setError(false);
      setPassword(firstPassword);
    } else {
      setError(true);
    }
  }, [firstPassword, lastPassword]);

  return (
    <>
      <div style={{ paddingBottom: 10 }}>
        <PasswordField
          password={firstPassword}
          setPassword={setFirstPassword}
          id="Ingresar contraseña"
          disabled={disabled}
        />
      </div>
      <div style={{ paddingBottom: 20 }}>
        <PasswordField
          password={lastPassword}
          setPassword={setLastPassword}
          id="Confirmar contraseña"
          disabled={disabled}
        />
      </div>
      <Typography variant="caption" component="div" color="textSecondary" gutterBottom>Requisitos</Typography>
      <div style={{
        paddingInline: 5, paddingBlock: 8, backgroundColor: 'whitesmoke', borderRadius: 5, boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)',
      }}
      >
        <Typography
          variant="caption"
          component="div"
          color={stateColorSwitch(checkLength)[0]}
          sx={requestStyle}
        >
          • Largo entre 8 y 15 caracteres
          {' '}
          {stateColorSwitch(checkLength)[1]}
        </Typography>
        <Typography
          variant="caption"
          component="div"
          color={stateColorSwitch(checkLettersAndNumbers)[0]}
          sx={requestStyle}
        >
          • Al menos una letra y un número
          {' '}
          {stateColorSwitch(checkLettersAndNumbers)[1]}
        </Typography>
        <Typography
          variant="caption"
          component="div"
          color={stateColorSwitch(checkSpecialCharacters)[0]}
          sx={requestStyle}
        >
          • Al menos un caracter especial (@$!%*#?&-.)
          {' '}
          {stateColorSwitch(checkSpecialCharacters)[1]}
        </Typography>
        <Typography
          variant="caption"
          component="div"
          color={stateColorSwitch(passDiff)[0]}
          sx={requestStyle}
        >
          • Ambas contraseñas deben coincidir
          {' '}
          {stateColorSwitch(passDiff)[1]}
        </Typography>
      </div>
    </>
  );
}

PasswordForm.defaultProps = {
  disabled: false,
};

export default PasswordForm;
